module.exports = "/assets/dist/img/selection-placeholder.png?60f9738d8046e54f84e583fbbd0d6722";


//////////////////
// WEBPACK FOOTER
// ./WebResources/vue/shared/img/selection-placeholder.png
// module id = 563
// module chunks = 0 2